import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import logo from "../assets/projects/logo.png";
import { navItems } from "../data";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("home");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 24);

      const current = [...navItems].reverse().find((item) => {
        const element = document.getElementById(item.href);
        return element && window.scrollY >= element.offsetTop - 140;
      });

      if (current) setActive(current.href);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToSection = (href) => {
    document.getElementById(href)?.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-50 transition duration-300 ${
        scrolled ? "border-b border-white/10 bg-slate-950/78 shadow-2xl shadow-black/20 backdrop-blur-2xl" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between gap-3 px-4 py-3 sm:px-8 sm:py-4 lg:px-10">
        <button
          onClick={() => scrollToSection("home")}
          className="group inline-flex min-w-0 items-center gap-2 text-left sm:gap-3"
          aria-label="Нүүр хэсэг рүү очих"
        >
          <span className="h-11 w-16 shrink-0 overflow-hidden rounded-2xl border border-cyan-300/30 bg-slate-950/70 shadow-glow transition group-hover:scale-105 sm:h-12 sm:w-24">
            <img src={logo} alt="TN logo" className="h-full w-full object-cover" />
          </span>
          <span className="min-w-0">
            <span className="block truncate font-display text-xs font-extrabold tracking-wide text-white sm:text-sm">
              Төлепберген Нурлан
            </span>
            <span className="block truncate text-[11px] font-medium text-slate-400 sm:text-xs">Computer Science Student</span>
          </span>
        </button>

        <div className="hidden items-center gap-1 rounded-2xl border border-white/10 bg-white/[0.045] p-1 backdrop-blur-xl lg:flex">
          {navItems.map((item) => (
            <button
              key={item.href}
              onClick={() => scrollToSection(item.href)}
              className={`rounded-xl px-3.5 py-2 text-sm font-semibold transition ${
                active === item.href ? "bg-cyan-300/[0.15] text-cyan-100" : "text-slate-300 hover:bg-white/[0.08] hover:text-white"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        <button
          onClick={() => setOpen((value) => !value)}
          className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl border border-white/10 bg-white/5 text-slate-100 backdrop-blur-xl lg:hidden"
          aria-label="Цэс нээх"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="mx-5 mb-4 rounded-2xl border border-white/10 bg-slate-950/95 p-3 shadow-2xl shadow-black/30 backdrop-blur-2xl lg:hidden">
          {navItems.map((item) => (
            <button
              key={item.href}
              onClick={() => scrollToSection(item.href)}
              className="block w-full rounded-xl px-4 py-3 text-left text-sm font-semibold text-slate-200 hover:bg-white/[0.08]"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
